import { matchApi, tasksApi } from "@/api";
import { catchErrors } from "@/util/functions";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

const initialState = {
  matches: [],
  matchesCount: 0,
  teams: [],
  formError: null,
  loading: false,
};

export const createMatch = createAsyncThunk(
  "dashboard/createMatch",
  async (data, { dispatch }) => {
    try {
      await matchApi.createMatch(data);
      await dispatch(fetchDashboardMatchesList());
      dispatch(errorFormRemove());
    } catch (e) {
      dispatch(catchErrors(e, dashboardError));
    }
  }
);

export const fetchDashboardMatchesList = createAsyncThunk(
  "dashboard/fetchDashboardMatchesList",
  async ({ page = 1, search = "" } = {}, { rejectWithValue, dispatch }) => {
    try {
      const { results, count } = await matchApi.getMatchesList(page, search);
      dispatch(dashboardError("Something went wrong"));
      return { matches: results, count, isPagination: page > 1 };
    } catch (e) {
      return rejectWithValue(e);
    }
  }
);

export const continueVideoProcessing = createAsyncThunk(
  "dashboard/continueVideoProcessing",
  async ({ videoId, currentStage }, { dispatch }) => {
    try {
      await tasksApi.continueVideo(videoId, currentStage);
      dispatch(fetchDashboardMatchesList());
      return true;
    } catch (e) {
      dispatch(dashboardError(e));
    }
  }
);

export const restartVideoPipeline = createAsyncThunk(
  "dashboard/restartVideoPipeline",
  async (videoId, { dispatch }) => {
    try {
      await tasksApi.restartPipeline(videoId);
      await dispatch(fetchDashboardMatchesList());
    } catch (e) {
      dispatch(dashboardError(e));
    }
  }
);

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    dashboardError(state, action) {
      state.formError = action.payload;
    },
    errorFormRemove(state) {
      state.formError = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDashboardMatchesList.pending, (state) => {
        if (state.matches.length === 0) state.loading = true;
      })
      .addCase(fetchDashboardMatchesList.fulfilled, (state, action) => {
        state.loading = false;

        const { matches, count, isPagination } = action.payload;

        if (isPagination) {
          state.matches.push(...matches);
        } else {
          state.matches = matches;
          state.matchesCount = count ?? state.matchesCount;
        }
      })
      .addCase(fetchDashboardMatchesList.rejected, (state, action) => {
        state.loading = false;
        state.formError = action.payload;
      })
  },
});

export const { dashboardError, errorFormRemove } = dashboardSlice.actions;

export default dashboardSlice.reducer;
